<style scoped type="text/css">
.add-shipment-btn:focus {
  background-color: #9beaa391;
  opacity: 5 !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
  0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}
</style>
<template>
  <div>
    <v-form ref="bulk_shipment_form" class="custome-form" lazy-validation>
      <v-row justify="center">
        <v-col class="pr-4" cols="10" md="5">
          <div
              v-if="
              $store.state.user_type == $keys.WAREHOUSE ||
              $store.state.user_type == $keys.SUPER_ADMIN
            "
          >
            <p class="sub-title-text-dark large-screen">
              {{ $lang.WHOLESALER }}
            </p>
            <label class="small-screen">{{ $lang.WHOLESALER }}</label>

            <wholesaler-select-box
                :wholesaler="wholesaler"
                @update-wholesaler="getWholesaler"
            />
          </div>
        </v-col>
        <v-col class="pr-4" cols="10" md="4">
          <div
              v-if="
              $store.state.user_type == $keys.WAREHOUSE ||
              $store.state.user_type == $keys.SUPER_ADMIN
            "
          >
            <p class="sub-title-text-dark large-screen">
              {{ $lang.PICKUP_AGENT }}
            </p>
            <label class="small-screen">{{ $lang.PICKUP_AGENT }}</label>

            <agent-select-box
                :add_self="true"
                :agent_type="$keys.PICKUP_AGENT"
                :label="$keys.PICKUP_AGENT"
                :rules="$rules.PickupAgentRule"
                @update-pickup-agent="getPickupAgent"
            />
          </div>
        </v-col>
        <v-col class="pr-4" cols="10" md="3">
        </v-col>
      </v-row>
    </v-form>

    <v-row class="large-screen">
      <v-col class="py-0" cols="10" md="3">
        <p class="sub-title-text-dark">{{ $lang.RETAILER }}</p>
      </v-col>
      <v-col class="py-0" cols="10" md="2">
        <p class="sub-title-text-dark">{{ $lang.CHALLAN_NUMBER }}</p>
      </v-col>
      <v-col class="py-0" cols="10" md="2">
        <p class="sub-title-text-dark">{{ $lang.AMOUNT }}</p>
      </v-col>
      <v-col class="py-0" cols="10" md="2">
        <p class="sub-title-text-dark">{{ $lang.NUMBER_OF_PACKETS }}</p>
      </v-col>
      <v-col class="py-0" cols="10" md="2">
        <p class="sub-title-text-dark">{{ $lang.METHOD }}</p>
      </v-col>
    </v-row>

    <v-form ref="bulk_shipment_form_2" class="custome-form" lazy-validation>
      <v-row v-for="(item, i) in shipment_data_list" :key="i" justify="center">
        <v-col class="pr-4" cols="10" md="3">
          <label class="small-screen">{{ $lang.RETAILER }}</label>
          <v-combobox
              :id="'retailer_' + (i+1)"
              v-model="item.retailer"
              :disabled="i==(shipment_data_list.length-1)?false:true"
              :items="retailer_list"
              :label="$lang.RETAILER"
              :loading="item.loading"
              :placeholder="$lang.RETAILER"
              :rules="$rules.reatilerRule"
              :search-input.sync="item.retailer_search_query"
              append-icon="mdi-menu-down"
              clearable
              dense
              item-text="retailer_firm_name"
              item-value="retailer_id"
              outlined
              single-line
              @change="setRetailer(item.retailer.retailer_id, item, i)"
              @focus="searchRetailer(item)"
              @keydown="searchRetailer(item)"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title
                    v-html="data.item.retailer_firm_name"
                ></v-list-item-title>
                <v-list-item-subtitle
                    v-html="data.item.retailer_location"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-combobox>
        </v-col>
        <v-col class="pr-4" cols="10" md="2">
          <label class="small-screen">{{ $lang.CHALLAN_NUMBER }}</label>
          <v-text-field
              :id="'challan_id_' + i"
              v-model="item.challan_number"
              :disabled="i==(shipment_data_list.length-1)?false:true"
              :placeholder="$lang.CHALLAN_NUMBER"
              :rules="$rules.challanNumberRule"
              dense
              outlined
              single-line
          ></v-text-field>
        </v-col>
        <v-col class="pr-4" cols="10" md="2">
          <label class="small-screen">{{ $lang.AMOUNT }}</label>
          <v-text-field
              v-model="item.shipment_amount"
              :disabled="i==(shipment_data_list.length-1)?false:true"
              :placeholder="$lang.AMOUNT"
              :rules="$rules.amountRule"
              dense
              maxlength="6"
              outlined
              single-line
          ></v-text-field>
        </v-col>
        <v-col class="pr-4" cols="10" md="2">
          <label class="small-screen">{{ $lang.NUMBER_OF_PACKETS }}</label>
          <v-select
              v-model="item.number_of_packets"
              :disabled="i==(shipment_data_list.length-1)?false:true"
              :items="number_of_packets_options"
              :placeholder="$lang.NUMBER_OF_PACKETS"
              dense
              outlined
              singlenide
          ></v-select>
        </v-col>
        <v-col class="pr-4" cols="10" md="2">
          <label class="small-screen">{{ $lang.METHOD }}</label>
          <v-select
              v-model="item.payment_mode"
              :disabled="i==(shipment_data_list.length-1)?false:true"
              :items="methods"
              :placeholder="$lang.METHOD"
              dense
              outlined
          ></v-select>
        </v-col>
        <v-col cols="10" md="1">
          <v-btn
              v-if="item.shipment_id"
              fab
              small
              text
              @click="printShipmentDetails(item.shipment_id)"
          >
            <v-icon color="#6D7C8E" small> mdi-printer</v-icon>
          </v-btn>

          <!--          <v-icon-->
          <!--              v-if="i!=(shipment_data_list.length-1)"-->
          <!--              color="primary">mdi-checkbox-marked-circle-outline-->
          <!--          </v-icon>-->
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="pr-4" cols="10" md="5">
          <span class="sub-title-text-dark">{{ $lang.TOTAL }}: </span
          ><span class="sub-title-text">{{ shipment_data_list.length }}</span>
        </v-col>
        <v-col class="pt-0" cols="6" md="2">
          <v-btn
              class="border-btn-style add-shipment-btn"
              color="primary"
              text
              @click="createShipments"
          >
            <img
                alt=""
                class="mr-1"
                src="../../assets/add-shipment.svg"
                style="margin-bottom: 1px"
                width="16px"
            />
            <b>{{ $lang.ADD_SHIPMENT }}</b>
          </v-btn>
        </v-col>
        <v-col class="pt-0" cols="6" md="2">
                    <ShippingLable :shipment_id_list="shipment_id_list" btn_type="1"></ShippingLable>
        </v-col>
      </v-row>
    </v-form>
<!--    <ShippingLable :shipment_id_list="shipment_id_list" btn_type="1"></ShippingLable>-->
  </div>
</template>

<script type="text/javascript">
export default {
  components: {
    WholesalerSelectBox: () =>
        import("@/components/common-components/WholesalerSelectBox.vue"),
    AgentSelectBox: () =>
        import("@/components/common-components/AgentSelectBox.vue"),
    ShippingLable: () =>
        import("@/components/common-components/ShippingLable.vue"),
  },
  data() {
    return {
      btn_loding: false,
      retailer_list: [],
      retailer_search_query: "",
      methods: ["Cash", "Credit"],
      wholesaler: null,
      pickup_agent: null,
      number_of_packets_options: [1],
      old_row: [],
      shipment_id_list: [],
      shipment_data_list: [
        {
          retailer_search_query: "",
          retailer: null,
          retailer_id: "",
          challan_number: "",
          number_of_packets: 1,
          shipment_amount: null,
          payment_mode: "Credit",
          loading: false,
          shipment_id: "",
        },
      ],
    };
  },
  methods: {
    getWholesaler(wholesaler) {
      this.wholesaler = wholesaler;
    },
    getPickupAgent(agent) {
      this.pickup_agent = agent;
    },
    searchRetailer(item) {
      this.retailer_search_query = item.retailer_search_query;
      this.retailerAutoComplete(item);
    },
    setRetailer(retailer_id, item, i) {
      item.retailer_id = retailer_id;
      document.getElementById("challan_id_" + i).focus();
    },

    /* fetching the  retailer  from API*/
    retailerAutoComplete(item) {
      const self = this;
      let params = {
        search_query: self.retailer_search_query,
      };
      item.loading = true;
      const successHandler = (response) => {
        self.retailer_list = response.data.retailer_list;
      };
      const finallyHandler = () => {
        item.loading = false;
      };
      self.request_GET(
          self,
          self.$urls.RETAILER_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          true
      );
    },
    /* adding row for shipment details*/
    AddRow() {
      let length = this.shipment_data_list.length.toString();

      let new_row = {
        retailer_search_query: "",
        retailer: null,
        retailer_id: "",
        challan_number: "",
        number_of_packets: 1,
        shipment_amount: null,
        payment_mode: "Credit",
        loading: false,
        shipment_id: "",
      };
      this.shipment_data_list.push(new_row);

      setTimeout(() => {
        document.getElementById("retailer_" + this.shipment_data_list.length).focus();
      }, 500);
    },
    /* Api call for the creating shipment  */
    createShipments() {
      const self = this;
      if (
          this.$refs.bulk_shipment_form.validate() == false ||
          this.$refs.bulk_shipment_form_2.validate() == false
      )
        return false;
      console.log(self.old_row);

      // finding the pament mode
      let payment_mode = "Credit";
      for (let i = 0; i < this.shipment_data_list.length; i++) {
        if (this.shipment_data_list[i].payment_mode == "Cash")
          payment_mode = "Cash";
      }

      self.btn_loding = true;
      var form = new FormData();
      if (this.wholesaler)
        form.append("wholesaler_id", self.wholesaler.wholesaler_id);
      if (this.pickup_agent)
        form.append("pickup_agent_id", self.pickup_agent.id);

      let shipment_list = [];
      shipment_list.push(
          self.shipment_data_list[self.shipment_data_list.length - 1]
      );
      form.append("shipment_list", JSON.stringify(shipment_list));
      form.append("payment_mode", payment_mode);

      const successHandler = (response) => {
        if (response.data.success) {
          self.shipment_data_list[self.shipment_data_list.length - 1].shipment_id = response.data.shipment_id;
          self.AddRow();
          self.showSnakeBar("success", response.data.message);
          self.bulkPrint()
        }
      };
      const finallyHandler = () => {
        self.btn_loding = false;
      };

      this.request_POST(
          self,
          this.$urls.CREATE_BULK_SHIPMENT,
          form,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
    /* print shipment details */
    printShipmentDetails(shipment_id) {
      console.log("methods_13");

      this.$store.dispatch("setPageLoader", true);
      const self = this;
      const reqListener = () => {
        var arrayBuffer = xhr.response;
        var fileURL = URL.createObjectURL(xhr.response);
        window.open(fileURL);
        this.$store.dispatch("setPageLoader", false);
      };

      let url =
          this.$urls.BASE_URL + "shipment/get-pdf/?shipment_id=" + shipment_id + "&user_type=" + this.$store.state.user_type;
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", reqListener);
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.overrideMimeType("application/pdf; charset=x-user-defined");
      xhr.send();
    },
    /*bulk print shipping label*/
    bulkPrint() {
      let shipment_id_list = [];
      for (let i = 0; i < this.shipment_data_list.length; i++) {
        shipment_id_list.push(this.shipment_data_list[i].shipment_id);
      }
      console.log(shipment_id_list)
      this.shipment_id_list = JSON.stringify(shipment_id_list);
      // this.$store.dispatch("setPageLoader", true);
      // const self = this;
      // const reqListener = () => {
      //   var arrayBuffer = xhr.response;
      //   var fileURL = URL.createObjectURL(xhr.response);
      //   window.open(fileURL);
      //   this.$store.dispatch("setPageLoader", false);
      // };
      //
      // let url =
      //     this.$urls.BASE_URL + "shipment/get-bulk-pdf/?shipment_id_list=" + this.shipment_id_list + "&user_type=" + this.$store.state.user_type;
      // var xhr = new XMLHttpRequest();
      // xhr.addEventListener("load", reqListener);
      // xhr.open("GET", url);
      // xhr.responseType = "blob";
      // xhr.overrideMimeType("application/pdf; charset=x-user-defined");
      // xhr.send();
    },
  },
};
</script>